import axios from "axios";

const state = {
  userData: {},
  lockedUsers: [],
};

const getters = {
  userData: (state) => state.userData,
  lockedUsers: (state) => state.lockedUsers,
};

const actions = {
  userAuth({ commit, dispatch }, userData) {
    userData.etkContract = true;
    delete axios.defaults.headers.common["Authorization"];
    axios
      .post("/api/panel/auth/login", userData)
      .then((response) => {
        if (response.data.processStatus === "Success") {
          const accessToken = response.data.payload.accessToken;
          const refreshToken = response.data.payload.refreshToken;
          const payload = accessToken.split(".")[1];
          const decoder = new TextDecoder("utf-8");
          const tokenDecodeData = JSON.parse(
            decoder.decode(base64UrlDecode(payload)),
          );
          getUserRoles(accessToken);
          localStorage.setItem("frinkUserToken", accessToken);
          localStorage.setItem("refreshToken", refreshToken);
          axios.defaults.headers.common["Authorization"] =
            "Bearer " + accessToken;
          dispatch("getPanelUserById", tokenDecodeData.id).then((res) => {
            const result = res;
            if (result) {
              localStorage.setItem(
                "nameSurname",
                result.firstName + " " + result.lastName,
              );
              localStorage.setItem("email", result.email);
            }
            window.location.href = "/dashboard";
          });
          return true;
        } else {
          alert(response.data.friendlyMessage.message);
          return false;
        }
      })
      .catch((err) => {
        console.log(err);
        if (
          err.response.data.friendlyMessage.message ===
          "email_or_password_incorrect"
        ) {
          alert("E-posta veya şifre yanlış.");
        } else alert("Bir hata oluştu");
        throw err;
      });
  },
  forgotPassword({ commit }, userData) {
    return axios.post("/api/panel/auth/forgot-password", userData);
  },
  getUser({ commit }, userId) {
    return axios.get(`/api/panel/frink-user/${userId}`).then((response) => {
      commit("setUserData", response.data.payload);
      return response.data;
    });
  },
  checkUserValid({ commit }, userId) {
    return axios.get(`/api/panel/frink-user/${userId}`).then((response) => {
      return response.data;
    });
  },
  resetUserImgUpdateCount({ commit }, userId) {
    return axios
      .put(`/api/panel/frink-user/reset-img-update-count/${userId}`)
      .then((response) => {
        return response.data;
      });
  },
  removeUserSubscription({ commit }, userId) {
    return axios
      .post(`/api/panel/frink-user/remove-subscription/${userId}`)
      .then((response) => {
        return response.data;
      });
  },
  getPanelUserById({ commit }, userId) {
    return axios
      .get(`/api/panel/paneluser/panel-user/${userId}`)
      .then((response) => {
        console.log(response);
        return response.data.payload;
      });
  },
  getLockedUsers({ commit }, userPageData) {
    commit("setLoading", true);
    return axios
      .get(
        `/api/panel/frink-user/device-list?page=${userPageData.pageNumber}&size=${userPageData.pageSize}&search=${userPageData.search}`,
      )
      .then((response) => {
        commit("setLockedUsers", response.data.payload.items);
        commit("setLoading", false);
        return response.data.payload;
      });
  },
  async unlockUserDevice({ commit }, userId) {
    return await axios
      .post(`/api/panel/frink-user/${userId}/unlock-device`)
      .then((response) => {
        return response.data;
      });
  },
};

const mutations = {
  setUserData: (state, userData) => {
    let names = userData.fullName.split(" ");
    userData.lastName = names[names.length - 1];
    userData.firstName = names.filter((u) => u != userData.lastName).join(" ");
    userData.subscription =
      userData.subscriptionPlanName +
      " - " +
      userData.subscriptionPlanTimePeriod +
      " - " +
      userData.subscriptionPlanDescription;
    state.userData = userData;
  },
  setPanelUserData: (state, userData) => {
    state.userData = userData;
  },
  setLockedUsers: (state, lockedUsers) => {
    state.lockedUsers = lockedUsers;
  },
};

function base64UrlDecode(base64Url) {
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const buffer = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));
  return buffer;
}

export function getUserRoles(token) {
  const userToken = token ? token : localStorage.getItem("frinkUserToken");
  if (!userToken) {
    userLogout();
    return;
  }
  const payload = userToken.split(".")[1];
  const decoder = new TextDecoder("utf-8");
  const tokenDecodeData = JSON.parse(decoder.decode(base64UrlDecode(payload)));
  localStorage.setItem("userRoles", JSON.stringify([tokenDecodeData.roleName]));
}

export function userLogout() {
  localStorage.removeItem("frinkUserToken");
  localStorage.removeItem("nameSurname");
  localStorage.removeItem("userRoles");
  localStorage.removeItem("email");
  localStorage.removeItem("refreshToken");
  if (!window.location.pathname === "/") window.location.href = "/";
  return;
}
export default {
  state,
  getters,
  actions,
  mutations,
};
